import { calculateArea } from "@nova/calculate-geospatial"
import { SATELLITE_PROCESSING_MS_PER_KM2, SatelliteSensorType } from "@nova/constants"
import { Coordinate } from "@nova/protobuf"

export const estimateSatelliteProcessingSeconds = (
    region: Coordinate[] | undefined,
    sensorType: SatelliteSensorType | undefined
): number | undefined => {
    if (!region?.length || sensorType === undefined) return undefined
    const areaKm2 = calculateArea(region) / 1_000_000
    return (areaKm2 * SATELLITE_PROCESSING_MS_PER_KM2[sensorType]) / 1000
}
